import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const vatRateService = {
  getVatRates: async () => {
    const response = await api.get('/vat-rates');
    return response.data;
  },
  createVatRate: async (data) => {
    const response = await api.post('/vat-rates', data);
    return response.data;
  },
  deleteVatRate: async (id) => {
    const response = await api.delete(`/vat-rates/${id}`);
    return response.data;
  },
};
